/**
 * Nathan's replaceable BOS scene slots.
 *
 * Put new optimized background files in `public/assets/`, then change only the
 * matching value below. Keeping these paths together avoids editing the login,
 * shell, and dashboard components every time the visual direction changes.
 */
const prismCommandBackdrop = '/assets/prism-command-backdrop.jpg';
const phoenixCobaltStaircase = '/assets/phoenix-cobalt-staircase.jpg';
const phoenixBrandMark = '/assets/phoenix-mark-orange.png';

export const PHOENIX_SCENE_SLOTS = {
  login: prismCommandBackdrop,
  dashboardShell: prismCommandBackdrop,
  personalLane: prismCommandBackdrop,
  phoenixLane: phoenixCobaltStaircase,
  phoenixBrandMark,
  industryRockstarLane: null,
} as const;

